export default __webpack_public_path__ + "static/media/pdo_threads.06349508.pdf";